import { useRouter } from '../useRouter';

export const usePathParams = () => {
  const { pathParams } = useRouter();

  return { pathParams };
};
